import { createStore, applyMiddleware, Store, Middleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import logger from 'redux-logger'
import { RootState } from 'src/state/reducer'
import rootReducer from 'src/state/reducer'

import securitySagas from 'src/features/Security/state/sagas'
import userSagas from 'src/features/User/state/sagas'
import commonSagas from 'src/common/state/sagas'
import customerSagas from 'src/features/Customer/state/sagas'
import serviceSagas from 'src/features/Service/state/sagas'
import serviceContractSagas from 'src/features/ServiceContract/state/sagas'
import contractDebitPaymentSagas from 'src/features/CustomerPayment/state/sagas'
import cashboxSagas from 'src/features/CashboxStatement/state/sagas'
import chatSagas from 'src/features/Chat/state/sagas'
import accountPayablesSagas from 'src/features/AccountPayable/state/sagas'
import payableContractSagas from 'src/features/PayableContract/state/sagas'
import reportSagas from 'src/features/Report/state/sagas'
import quotationSagas from 'src/features/Quotation/state/sagas'

const sagas = createSagaMiddleware()
const middleware: [Middleware] = [sagas]

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    middleware.push(logger);
}

const store: Store<RootState> = createStore(
    rootReducer,
    applyMiddleware(...middleware)
);

sagas.run(accountPayablesSagas)
sagas.run(securitySagas)
sagas.run(cashboxSagas)
sagas.run(chatSagas)
sagas.run(commonSagas)
sagas.run(userSagas)
sagas.run(customerSagas)
sagas.run(payableContractSagas)
sagas.run(quotationSagas)
sagas.run(reportSagas)
sagas.run(serviceSagas)
sagas.run(serviceContractSagas)
sagas.run(contractDebitPaymentSagas)

export default store;
